// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"566":"9b7656c3","887":"9b7656c3"}[chunkId] + ".chunk.css";
};